import { render, staticRenderFns } from "./VuesticIconVuestic.vue?vue&type=template&id=187043fa"
import script from "./VuesticIconVuestic.vue?vue&type=script&lang=js"
export * from "./VuesticIconVuestic.vue?vue&type=script&lang=js"
import style0 from "./VuesticIconVuestic.vue?vue&type=style&index=0&id=187043fa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports